module.exports = __webpack_public_path__ + "img/v_accept.85b4013c.svg";